import React from "react";
import Post from "./../../../Post";
import MediaTag from "../../../../shared/MediaTag";
import PlaylistSquareTag from "../../../../shared/PlaylistSquareTag";
import Album from "../../../../shared/Album";

const Attachment = ({ post, attachment }) => {
  switch (attachment.type) {
    case "SoundTrack":
      return (
        <MediaTag
          className="my-2"
          showProgress
          source={post}
          medium={attachment}
        />
      );
    case "Image":
      return (
        <MediaTag
          className="img-fluid"
          showFullScreenImag
          medium={attachment}
        />
      );
    case "Video":
      return <MediaTag medium={attachment} className="w-100" />;
    case "Post":
      return <Post post={attachment} className="mx-5" />;
    case "Playlist":
      return <PlaylistSquareTag playlist={attachment} className="mx-5" />;
    case "Album":
      return <Album album={attachment} />;
    case "Podcast":
      return <PlaylistSquareTag playlist={attachment} className="mx-5" />;
    default:
      return JSON.stringify(attachment);
  }
};

export default ({ post, attachments, attachmentsSetter = undefined }) =>
  attachments.length
    ? attachments.map((attachment) => (
        <Attachment post={post} attachment={attachment} key={attachment.id} />
      ))
    : null;
